import axios from "axios";
import { isString } from "formik";
import { toast } from "react-toastify";

import localStorageService from "./LocalStorageService";
import { getPropFromJSON } from "utils/functions";
import { scanHeaders } from "./scanHeaders";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Accept-Language": "pt-BR",
    client_id: process.env.REACT_APP_CLIENT_ID,
    ...scanHeaders,
  },
});

api.interceptors.response.use(
  (response) => {
    const responseJson = response.request.response;

    // Parse to string customerSiteId
    if (
      response.data.customerSiteId &&
      !isString(response.data.customerSiteId)
    ) {
      response.data.customerSiteId = getPropFromJSON(
        "customerSiteId",
        responseJson
      );
    } else if (
      response.data[0] &&
      response.data[0].customerSiteId &&
      !isString(response.data[0].customerSiteId)
    ) {
      response.data[0].customerSiteId = getPropFromJSON(
        "customerSiteId",
        responseJson
      );
    }

    // Parse to string siteId
    if (response.data.siteId && !isString(response.data.siteId)) {
      response.data.siteId = getPropFromJSON("siteId", responseJson);
    }

    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      return refreshToken();
    }
    return Promise.reject(error);
  }
);

const resetLocalStorage = (): void => {
  localStorage.removeItem("@UltragazEmpresarial:customerSiteCode");
  localStorage.removeItem("@UltragazEmpresarial:customerSiteId");
  localStorage.removeItem("@UltragazEmpresarial:customerCode");
  localStorage.removeItem("@UltragazEmpresarial:customerId");
  localStorage.removeItem("@UltragazEmpresarial:customerName");
  localStorage.removeItem("@UltragazEmpresarial:userCustomerRelationshipId");
  localStorage.removeItem("@UltragazEmpresarial:userName");
  localStorage.removeItem("@UltragazEmpresarial:customerType");
  localStorage.removeItem("@UltragazEmpresarial:refreshToken");
  localStorage.removeItem("@UltragazEmpresarial:accessToken");
  localStorage.removeItem("@UltragazEmpresarial:commercialRegion");
  localStorage.removeItem("@UltragazEmpresarial:userId");
  localStorage.removeItem("@UltragazEmpresarial:loginEmail");
  localStorage.removeItem("@UltragazEmpresarial:document");
  localStorage.removeItem("@UltragazEmpresarial:customerAddressLine");
  localStorage.removeItem("@UltragazEmpresarial:unitData");
};

const refreshToken = async (): Promise<void> => {
  const req = axios.create({
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Accept-Language": "pt-BR",
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    "Content-Type": "application/json",
    "Accept-Language": "pt-BR",
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };
  const config = {
    headers: header,
  };
  const body = {
    grant_type: "refresh_token",
    refresh_token: await localStorage.getItem(
      "@UltragazEmpresarial:refreshToken"
    ),
  };
  req
    .post("oauth/access-token", body, config)
    .then((res) => {
      if (res.status === 201) {
        const urlAtual = window.location.href;
        window.location.href = urlAtual;
        localStorageService.setToken(res.data);
      }
    })
    .catch(() => {
      toast.error("Sua sessão foi expirada, faça login novamente no sistema!");
      resetLocalStorage();

      window.location.href = "/acessar";
    });
};

const { isAxiosError } = axios;
export default api;
export { isAxiosError };
